<template>
  <div>
    <div class="price_area">
      <!-- <div>
        <span class="discounted">{{priceArea.discounted}}</span>
        <span class="original">￥{{priceArea.original}}</span>
        <span class="price">￥{{priceArea.price}}</span>
        <span v-if="tenDiscount" class="price_discount">{{priceArea.price_discount}}</span>
      </div>-->
      <van-row gutter="10">
        <van-col class="discounted">{{priceArea.discounted}}</van-col>
        <van-col class="original">￥{{priceArea.original}}</van-col>
        <van-col class="price">￥{{priceArea.price}}</van-col>
        <van-col class="price_discount" v-if="tenDiscount">{{priceArea.price_discount}}</van-col>
      </van-row>
      <div class="van-multi-ellipsis--l2">{{priceArea.pricetitle}}</div>
      <div class="right">
        <van-row gutter="20" type="flex" justify="end">
          <van-col class="right_record">{{priceArea.right_pay}}</van-col>
          <van-col class="right_record">库存{{priceArea.totalStock}}</van-col>
          <van-col class="right_record">{{priceArea.right_watch}}</van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PriceArea',
  data() {
    return {}
  },
  props: {
    priceArea: {
      type: Object,
      default() {
        return {}
      }
    },
    tenDiscount: {
      type: Boolean
    }
  }
}
</script>

<style lang="less" scoped>

.price_area {
  // margin: 18px 30px;
  padding: 9px 15px;
  background-color: #fff;
  .discounted {
    margin-left: 0.5px;
    vertical-align: middle;
    width: auto;
    // height: 46px;
    // line-height: 46px;
    display: inline-block;
    padding: 6px;
    color: white;
    font-size: 15px;
    text-align: center;
    background: @discount-price;
    //  -webkit-gradient(
    //   linear,
    //   left 0,
    //   right 100%,
    //   from(#ddb8c8),
    //   to(#ff0600)
    // );
    opacity: 0.6;
    border-radius: 7.5px;
  }
  .price {
    text-decoration: line-through;
    font-size: 15px;
    color: #9fa0a0;
    height: 25px;
    line-height: 25px;
    padding-top: 3px;
  }
  .original {
    height: 24px;
    line-height: 24px;
    font-size: 25px;
    font-weight: 300px;
    padding-top: 3px;
  }
  .price_discount {
    height: 25px;
    line-height: 25px;
    font-size: 15px;
    color: #9fa0a0;
    padding-top: 3px;
  }
  .van-multi-ellipsis--l2 {
    letter-spacing: 1px;
    line-height: 20px;
    font-weight: 500px;
    font-size: 15px;
    margin: 7.5px 0;
  }
}

.right {
  margin-top: 5px;
}
.right_record {
  line-height: 15px;
  font-size: 12px;
  color: #9fa0a0;
}
</style>
